import React from 'react';
import { Stack, Typography } from '@mui/material';
import { SwapHorizOutlined as SwapIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Campo opcional — texto livre da IA, por isso trunca em uma linha só.
const LeadExchange = ({ exchange }) => {
  const { t } = useTranslation();

  if (!exchange) return null;

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <SwapIcon
        fontSize="small"
        color="action"
        titleAccess={t('leads.exchange')}
        sx={{ flexShrink: 0 }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
        noWrap
        sx={{ flex: 1, minWidth: 0 }}
      >
        {exchange}
      </Typography>
    </Stack>
  );
};

export default LeadExchange;
